import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/**
 * The grid's own name cell, worn as the card's title.
 *
 * That cell is drawn for a table row - an underlined `button`-variant label inside a button - while a
 * card's title reads at the 15px/600 every other list card uses. Only the type is overridden here:
 * the tap, and with it the destination and the tenant it makes active, stays the cell's own, which is
 * what keeps the card and the row on the same record.
 */
export const titleCellSx: SxProps<Theme> = {
    minWidth: 0,
    '& .MuiButton-root': {
        minWidth: 0,
        maxWidth: '100%',
        padding: 0,
        justifyContent: 'flex-start',
        textAlign: 'left',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    '& .MuiTypography-root': {
        fontSize: '15px',
        fontWeight: 600,
        lineHeight: 1.25,
        textTransform: 'none',
        color: theme.palette.text.primary,
        textDecoration: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};
